function triggerAnalytics(options) {
	try {
		window.dataLayer.push({...options});
	} catch (error) {
		console.error('Google Analytics error:', error);
	}
}

export {
  triggerAnalytics
}
